/**************************************************************************
Name:         main.js
Description:  Site scripting.
Date Created: 09/27/2012 by Kyle Brickman
Modified:     02/16/2015 by Roxanne Martinez - added Redactor
**************************************************************************/

/* Site navigation */
loadEvents.push(function(){
	(function($, window, document, undefined){
		/* Controls the visibility of the header bar when scrolling */
		'use strict';

		var elSelector = 'header .flexnav',
			elClassHidden = 'nav-hidden',
			throttleTimeout = 500,
			$element = $(elSelector),
			$hMenu = $('.mNavMenu');

		if(!$element.length) return true;

		var $window			= $(window),
			wHeight			= 0,
			wScrollCurrent	= 0,
			wScrollBefore	= 0,
			wScrollDiff		= 0,
			$document		= $(document),
			dHeight			= 0,

			throttle = function(delay, fn)
			{
				var last, deferTimer;
				return function()
				{
					var context = this, args = arguments, now = +new Date;
					if(last && now < last + delay)
					{
						clearTimeout(deferTimer);
						deferTimer = setTimeout(function(){ last = now; fn.apply(context, args); }, delay);
					}
					else
					{
						last = now;
						fn.apply(context, args);
					}
				};
			};

		$window.on('scroll', throttle(throttleTimeout, function(){
			dHeight			= $document.height();
			wHeight			= $window.height();
			wScrollCurrent	= $window.scrollTop();
			wScrollDiff		= wScrollBefore - wScrollCurrent;

			if ($element.hasClass('active')) return;

			if(wScrollCurrent <= 0) {// scrolled to the very top; element sticks to the top
				$element.removeClass(elClassHidden);
				$hMenu.removeClass('is-up');
			}

			else if(wScrollDiff > 0 && $element.hasClass(elClassHidden)) { // scrolled up; element slides in
				$element.removeClass(elClassHidden);
				$hMenu.removeClass('is-up');
			}

			else if(wScrollDiff < 0) // scrolled down
			{
				if(wScrollCurrent + wHeight >= dHeight && $element.hasClass(elClassHidden)) { // scrolled to the very bottom; element slides in
					$element.removeClass(elClassHidden);
					$hMenu.removeClass('is-up');
				}

				else { // scrolled down; element slides out
					$element.addClass(elClassHidden);
					$hMenu.addClass('is-up');
				}
			}

			wScrollBefore = wScrollCurrent;
		}));

	})(jQuery, window, document);

	var nav = {
		inputClick   : 'click',
		inputUp      : window.PointerEvent ? 'pointerup'    : window.MSPointerEvent ? 'MSPointerUp'    : 'mouseup touchend touchcancel',
		inputEnter   : window.PointerEvent ? 'pointerenter' : window.MSPointerEvent ? 'MSPointerEnter' : 'mouseover touchstart',
		inputMove    : window.PointerEvent ? 'pointermove'  : window.MSPointerEvent ? 'MSPointerMove'  : 'mousemove touchmove',

		isStockAndroid : null != navigator.userAgent.toLowerCase().match(/android/) &&
						 null == navigator.userAgent.toLowerCase().match(/chrome/) &&
						 null == navigator.userAgent.toLowerCase().match(/firefox/) &&
						 null == navigator.userAgent.toLowerCase().match(/opera/),

		calculate : function()
		{
			///* Landscape */
			if ($('.mobile-block').css("display") == "none")
			{
				$('.mobile-block').attr("disabled", "disabled");
			}
			else
			{
				$('.mobile-block').removeAttr("disabled");
			}

			if ($('.tablet-block').css("display") == "none")
			{
				$('.tablet-block').attr("disabled", "disabled");
			}
			else
			{
				$('.tablet-block').removeAttr("disabled");
			}

			if ($('.desktop-block').css("display") == "none")
			{
				$('.desktop-block').attr("disabled", "disabled");
			}
			else
			{
				$('.desktop-block').removeAttr("disabled");
			}
		},

		setTrap : function()
		{
			var link  = $(this);

			link.attr('data-trap', 'true');
		},

		showNavPrimaryLink : function(evt)
		{
			var link  = $(this);

			if(link.hasClass('hover'))
				return;

			// nav.hideNavPrimaryLink();

			link.addClass('hover');
		},

		hideNavPrimaryLink : function(evt)
		{
			var link  = $('.mNavListLink.hover, .mNavListLinkText'),
				tgt = link.filter(evt.target),
				notTgt = link.not(evt.target);

			if(evt && notTgt.length <= 0)
				return;

			notTgt.removeClass('hover');
		},

		toggleDropdown : function(evt){
			/* Show or hide a mobile sub-menu */
			let parentNavItem = jQuery(evt.target).closest(".mNavListItem");
			if(parentNavItem.length > 0){
				parentNavItem.toggleClass("active");
			}
		},

		togglePortrait : function(evt){
			/* Toggles the mobile navigation menu */
			evt.preventDefault();
			evt.stopPropagation();

			let newNav = $(this).siblings('.mNavList, .mNavSecondary'),
				primaryBody = $('.primary-body'),
				tertiaryNavs = $('.mNavSecondItem');

			newNav.toggleClass('active');

			primaryBody.removeClass('nav-active');
			if (newNav.hasClass('active')) {
				primaryBody.addClass('nav-active');
				//Fix for when the navigation is hidden after the user scrolls down
				let flexnavElem = newNav.closest(".flexnav");
				flexnavElem.css("transition", "none");
				window.requestAnimationFrame(()=>{
					flexnavElem.removeClass("nav-hidden");
					window.requestAnimationFrame(()=>{
						flexnavElem.removeAttr("style");
					});
				});
			}

			tertiaryNavs.removeClass('active');

			return false;
		},

		hideNav : function(evt){
			/* Closes the mobile navigation menu */
			evt.preventDefault();
			evt.stopPropagation();

			var newNav = $('.mNavList, .mNavSecondary, .mNavSecondItem'),
				primaryBody = $('.primary-body');

			newNav.removeClass('active');
			primaryBody.removeClass('nav-active');

			return false;
		},

		hovGen : function(evt)
		{
			var link  = $(this);

			if(link.hasClass('hover'))
				return;

			link.addClass('hover');
		},

		hideHovGen : function(evt)
		{
			var link  = $('.hovEvt');

			if(evt && $('.hovEvt').filter(evt.target).length)
				return;

			link.removeClass('hover');
		},

		hideHovGen2 : function(evt){
			let target  = $(evt.target);
			let targetParent = target.parent('.hovTN');
			let targetAncestor = target.parentsUntil('.hovTN').parent('.hovTN');

			if(evt && (target.hasClass('hovTN') || targetParent.length > 0 || targetAncestor.length > 0)){
				return;
			}
			$('.hovTN').removeClass('hover');
		},

		init : function(){
			let self = this;
			self.calculate();
			$(window).on('resize orientationchange', self.calculate);

			$('.mNavToggleButton').on(self.inputClick, self.togglePortrait);
			$('.mNavCloseButton').on(self.inputClick, self.hideNav);

			$('body').on(self.inputUp + ' ' + self.inputMove, self.hideNavPrimaryLink);
			$('body').on(self.inputUp + ' ' + self.inputMove, self.hideHovGen);
			$('body').on(self.inputUp + ' ' + self.inputMove, self.hideHovGen2);
			$('.mNavListLink').on(self.inputEnter, self.showNavPrimaryLink);
			$('.hovEvt').on(self.inputEnter, self.hovGen);
			$('.hovTN').on(self.inputEnter, self.hovGen);
			$('.hasDropdown > button.mNavListLink').on(self.inputClick, self.toggleDropdown)
		}
	}
	
	nav.init();
});

/* IE 10 fix */
if (navigator.appVersion.indexOf('MSIE 10') != -1)
{
	$('html').addClass('is-ie');
	$('html').addClass('is-ie10');
	$('html').addClass('lt-ie11');
}

/* IE 11 fix */
if (navigator.appVersion.indexOf('Trident') != -1 && navigator.appVersion.indexOf('rv:11') != -1)
{
	$('html').addClass('is-ie');

	if (navigator.appVersion.indexOf('rv:11') != -1)
		$('html').addClass('is-ie11');
}

/* Legacy Android fix */
if(/android/i.test(navigator.userAgent))
{
	$('html').addClass('is-android');

	if(!/chrome/i.test(navigator.userAgent) &&
		!/firefox/i.test(navigator.userAgent) &&
		!/opera/i.test(navigator.userAgent))
		$('html').addClass('is-legacy-android');
}

if(/ip(hone|od|ad)/i.test(navigator.userAgent))
{
	$('html').addClass('is-ios');

	try{
		if(6 >= parseInt(navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1]))
			$('html').addClass('is-legacy-ios');
	}
	catch{}
}

 /* Windows touch device support */
/* Support for full site's top navigation on touch devices */
if(navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints > 0){ $('html').addClass('touch'); }

/* Redactor plugin storage

/* Displays site navigation dropdown if wireless */
loadEvents.push(function(){
	$(window).on('resize', function(evt){
		$('nav ul.sections').addClass('hiddenNav');
		updateTinyMCE();
	});
	window.setTimeout(updateTinyMCE, 500);

	$(document).mouseup(function (e)
	{
		var container = $("header.landscape");

		if (container.hasClass("active") && !container.is(e.target) && container.has(e.target).length === 0)
		{
			toggleContactForm();
		}
	});
});

/* Resizes fieldsets to maximum row height */
var resizeFieldsets = function()
{
	var fieldsets = $('fieldset').not('.controls');
	var currentTop    = 0;
	var currentHeight = 0;

	fieldsets.height('auto');

	for(var i = 0; i < fieldsets.length; i++)
	{
		var thisTop    = $(fieldsets[i]).offset().top;
		var thisHeight = $(fieldsets[i]).height();

		if(thisTop == currentTop)
		{
			if(thisHeight > currentHeight)
			{
				currentHeight = thisHeight;

				for(var j = i; j >= 0; j--)
				{
					if($(fieldsets[j]).offset().top == thisTop)
						$(fieldsets[j]).height(currentHeight);
					else
						j = 0;
				}
			}
			if(thisHeight < currentHeight)
			{
				$(fieldsets[i]).height(currentHeight);
			}
		}
		else
		{
			currentTop    = thisTop;
			currentHeight = thisHeight;
		}
	}
}

var updateTinyMCE = function()
{
	$('div.column.span_1_1 span.mceEditor table.mceLayout').each(function(){ resizeTinyMCE(this, .99,  0)})
	$('div.column.span_2_2 span.mceEditor table.mceLayout').each(function(){ resizeTinyMCE(this, .99,  0)})
	$('div.column.span_3_3 span.mceEditor table.mceLayout').each(function(){ resizeTinyMCE(this, .99,  0)})
	if($(window).width() > 568){
		$('div.column.span_1_2 span.mceEditor table.mceLayout').each(function(){ resizeTinyMCE(this, .49, 20)})
		$('div.column.span_2_3 span.mceEditor table.mceLayout').each(function(){ resizeTinyMCE(this, .65, 20)})
		$('div.column.span_1_3 span.mceEditor table.mceLayout').each(function(){ resizeTinyMCE(this, .32, 20)})
	}else{
		$('div.column.span_1_2 span.mceEditor table.mceLayout').each(function(){ resizeTinyMCE(this, .99,  0)})
		$('div.column.span_2_3 span.mceEditor table.mceLayout').each(function(){ resizeTinyMCE(this, .99,  0)})
		$('div.column.span_1_3 span.mceEditor table.mceLayout').each(function(){ resizeTinyMCE(this, .99,  0)})
	}
}

var resizeTinyMCE = function(instance, percentage, offset)
{
	var mceLayout = $(instance);
	var mceContainer = $('fieldset.controls').last();
	var mceColumn = $(instance).parent().parent().parent();
	var mceTextarea = $(instance).parent().siblings('textarea');

	//update width of the tinyMCE toolbar
	if(mceTextarea.hasClass('featureText')){
		if(mceColumn.width() < 315){
			mceLayout.find('td.mceToolbar td').each(function(){ $(this).css({ 'display': 'table-row', 'float' : 'left' }); });
			mceLayout.find('td.mceToolbar td:nth-of-type(11)').each(function(){ $(this).css({ 'clear' : 'left' }); });
		}else{
			mceLayout.find('td.mceToolbar td').each(function(){ $(this).css({ 'display': 'table-cell', 'float' : 'none' }); });
			mceLayout.find('td.mceToolbar td:nth-of-type(11)').each(function(){ $(this).css({ 'clear' : 'none' }); });
		}
	}else if(mceTextarea.hasClass('tinymceSmall')){
		if(mceColumn.width() < 385){
			mceLayout.find('td.mceToolbar td').each(function(){ $(this).css({ 'display': 'table-row', 'float' : 'left' }); });
			mceLayout.find('td.mceToolbar td:nth-of-type(11)').each(function(){ $(this).css({ 'clear' : 'left' }); });
		}else{
			mceLayout.find('td.mceToolbar td').each(function(){ $(this).css({ 'display': 'table-cell', 'float' : 'none' }); });
			mceLayout.find('td.mceToolbar td:nth-of-type(11)').each(function(){ $(this).css({ 'clear' : 'none' }); });
		}
	}else if(mceTextarea.hasClass('tinymceLarge')){
		if(mceColumn.width() < 735){
			mceLayout.find('td.mceToolbar td').each(function(){ $(this).css({ 'display': 'table-row', 'float' : 'left' }); });
			mceLayout.find('td.mceToolbar td:nth-of-type(11)').each(function(){ $(this).css({ 'clear' : 'left' }); });
		}else{
			mceLayout.find('td.mceToolbar td').each(function(){ $(this).css({ 'display': 'table-cell', 'float' : 'none' }); });
			mceLayout.find('td.mceToolbar td:nth-of-type(11)').each(function(){ $(this).css({ 'clear' : 'none' }); });
		}
	}

	mceLayout.width(mceContainer.width() * percentage - offset);
}

loadEvents[loadEvents.length] = function(){
	if($('fieldset').not('.controls').length)
	{
		$(window).on('orientationchange resize', resizeFieldsets);
		resizeFieldsets();
	}

	$('.posAwareButton').on('mouseenter', function(e) {
		var parentOffset = $(this).offset(),
			relX = e.pageX - parentOffset.left,
			relY = e.pageY - parentOffset.top;
		$(this).find('.paBG').css({top:relY, left:relX})
	}).on('mouseout', function(e) {
		var parentOffset = $(this).offset(),
			relX = e.pageX - parentOffset.left,
			relY = e.pageY - parentOffset.top;
		$(this).find('.paBG').css({top:relY, left:relX})
	});
}

loadEvents[loadEvents.length] = function(){
	$('div.homeBanner div.scroll a').click(function(e){
		e.preventDefault();
		$('html,body').animate({ 'scrollTop' : $('div.homeBanner').outerHeight() }, 1000);
	});
}

/* Slideshows */
loadEvents[loadEvents.length] = function(){
	var debounceTimer = new Date().getTime();
	var runningDebounce = null;
	//update homepage services
	$(window).on('resize orientationchange', function(evt){
		if($('.hpSlideshow .serviceCategory').length > 0 && $('.hpSlideshow .serviceCategory').eq(0).innerWidth() < (0.8 * $('.ourServices .servicesContent').outerWidth())){
			$('.hpSlideshow .serviceCategory').attr('style', '');
		}
		//Resize the Our Work slideshow if needed
		const debounceMinTime = 250;
		if(runningDebounce === null){
			if(new Date().getTime() - debounceTimer >= debounceMinTime){
				//The resizing can be run immediately
				resizeOurWorkSlideshow();
				debounceTimer = new Date().getTime();
			}
			else{	//Wait until the debounce time is reached
				runningDebounce = window.setTimeout(()=>{
					resizeOurWorkSlideshow();
					debounceTimer = new Date().getTime();
					runningDebounce = null;
				}, (debounceTimer + debounceMinTime) - new Date().getTime());
			}
		}
	});

	function resizeOurWorkSlideshow(){
		let slideTextArea = jQuery(".workDetails .ourWorkTextArea");
		if(jQuery(window).width() <= 768){
			let maxHeight = 0;
			slideTextArea.find(".workDetailsContent.slide").each((i,e)=>{
				//Find the height of the tallest slide
				maxHeight = Math.max(e.clientHeight, maxHeight);
			});
			slideTextArea.css("height", `${maxHeight}px`);
		}
		else{	//Clear the set height on the text area
			slideTextArea.css("height", "");
		}
	}
	resizeOurWorkSlideshow();	//Run on page load

	// hide arrows anytime there is only one slide or zero slides
	$('.slideshowLeft,.slideshowRight').each(function(){
		var slides = $(this).closest('.hpSlideshow').find('.slide');

		if(slides.length < 2) $(this).hide();
	});

	$('.slideshowLeft,.slideshowRight').click(function(evt){
		evt.preventDefault();

		let slides = $(this).closest('.hpSlideshow').find('.slide');
		let slides2 = $(this).closest('.hpSlideshow').find('.imgSlide');
		let slide = slides.filter('.active');
		let index = slide.prevAll().length;

		if($(this).hasClass('slideshowRight')){
			var newIndex = index - 1;
			var direction = -1;
		}else{
			var newIndex = index + 1;
			var direction = 1;
		}

		if(newIndex < 0) newIndex = slides.length - 1;
		if(newIndex >= slides.length) newIndex = 0;

		slides.eq(newIndex).css('left', -1 * (direction * 100) + '%');
		slides.filter('.active').animate({left: (direction *100) + '%'});
		slides.eq(newIndex).animate({left: '0%'});
		slides2.eq(newIndex).css('left', -1 * (direction * 100) + '%');
		slides2.filter('.active').animate({left: (direction * 100) + '%'});
		slides2.eq(newIndex).animate({left: '0%'});

		slides.filter('.active').removeClass('active');
		slides2.filter('.active').removeClass('active');
		slides.eq(newIndex).addClass('active');
		slides2.eq(newIndex).addClass('active');
	});
}

loadEvents[loadEvents.length] = function(){
	// $('.mNavListLinkContact').click(function(event) {
	// 	if (jQuery(window).width() <= 768) {
	// 		return true;
	// 	}
	// 	else {
	// 		event.preventDefault();
	// 		toggleContactForm();
	// 		window.setTimeout(()=>{jQuery(this).removeClass("isShrinkingUnderline")},10);
	// 		return false;
	// 	}
	// });
}
/* Homepage touch support for plus icons - http://www.hnldesign.nl/work/code/mouseover-hover-on-touch-devices-using-jquery/ - need fix for MS pointer events (ex: surface tablet) */
$('div.taphover').on("touchstart MSPointerEnter", function (e) {
	'use strict'; //satisfy code inspectors
	var link = $(this); //preselect the link
	if (link.hasClass('hover')) {
		return true;
	} else {
		link.addClass('hover');
		$('div.taphover').not(this).removeClass('hover');
		e.preventDefault();
		return false; //extra, and to make sure the function has consistent return points
	}
});

/* Slide in animation on scroll */
var animateSlideIn = function() {
	let windowHeight = jQuery(window).height();
	$(".animationElement,.toolTip,.blockBlue,.customerRatingGraph").not(".inView").each(function(i, el) {
		let elem = jQuery(el);
		if(visible(elem, true)){
			elem.trigger("partialScrolledIntoView");
			//Check if the element is 1/5 in view
			let elemPositioning = elem[0].getBoundingClientRect();
			if(windowHeight - elemPositioning.top >= (elemPositioning.height / 5)
				|| elemPositioning.top < (windowHeight / 2)){	//The top of the element is halfway up the viewport
				elem.addClass("inView").trigger("scrolledIntoView");
			}
		}
	});
}

loadEvents.push(function(){
	//Trigger slide in elements which wouldn't otherwise be triggerable
	window.requestAnimationFrame(()=>{
		jQuery(".animationElement").each(function(i,e){
			if(e.outerHeight > (window.innerHeight * 0.9)
				|| (e.getBoundingClientRect().top || 0) < 0){
				e.classList.add("inView");
			}
		});
	});

	//Trigger the scroll listener on page load in case there are animated elements in view already
	window.setTimeout(()=>{
		animateSlideIn();
	}, 50);
});

var trackManBun = function() {
	$(".manbun").each(function(i, el) {
		var el = $(el);;
		if (visible(el,false) && !el.hasClass('inView') && $(window).width() > 815) {
			el.addClass("inView");

			var eventCategory = 'Visitor',
				eventAction = 'Homepage View',
				eventLabel = 'Man Bun in view';
			trackGaEvent(eventCategory, eventAction, eventLabel);
		}
	});
}

$(window).scroll(animateSlideIn);
$(window).on('orientationchange resize', trackManBun);
$(window).scroll(trackManBun);
$(document).ready(function() {
	/* Google Analytics Event Tracking Code */
	$('.mNav a.logo').on('click', function(e) {
		getLinkData(e, $(this), 'A-VIBE Logo Click');
	});

	$('.mNavList a').on('click', function(e) {
		let el = $(this);
		let eventAction = 'Main Navigation Click';
		let paths = getPaths();
		let referer = paths.referer;
		let currentPath = paths.currentPath;

		if(el.attr('href') == undefined) {
			if(!el.parent().hasClass('active')) {
				let eventLabelText = 'Tertiary Nav Opened';
				trackLinkClick(el, eventAction, referer, currentPath, false, eventLabelText);
			}
		}
		else if($(window).width() > 768 && el.attr('href').indexOf('contact') > -1) {
			let eventLabelText = 'Form Opened';
			trackLinkClick(el, eventAction, referer, currentPath, false, eventLabelText);
		}
		else {
			getLinkData(e, el, eventAction);
		}

		/* Navigation link click animation */
		if(!el.parent().hasClass("projectContactButton")){
			el.addClass("isShrinkingUnderline");
		}
	});

	$('.mNavList .mNavSecondaryToggle').on('click', function() {
		let el = $(this).parent();
		let eventAction = 'Main Navigation Click';
		let paths = getPaths();
		let referer = paths.referer;
		let currentPath = paths.currentPath;
		let eventLabelText = 'Secondary Nav Opened';

		trackLinkClick(el, eventAction, referer, currentPath, false, eventLabelText);
	});

	$('a.plusContent').on('click', function(e) {
		getLinkData(e, $(this), 'Homepage Banner Plus Click');
	});

	$('.homeBanner a.posAwareButton').on('click', function(e) {
		getLinkData(e, $(this), 'Homepage Banner Scroll Button Click');
	});

	$('.section.main article a').on('click', function(e) {
		getLinkData(e, $(this), 'Main Content Link Click');
	});

	$('a.ctaLink').on('click', function(e) {
		getLinkData(e, $(this), 'CTA Button Click');
	});

	$('footer a').on('click', function(e) {
		getLinkData(e, $(this), 'Footer Link Click');
	});

	$('.contactArea a:not(.closeContact)').on('click', function(e) {
		getLinkData(e, $(this), 'Contact Area Link Click');
	});

	$('#contactForm, #portraitContactForm, #stayInformedForm, #consultationForm').on('focusout', function(evt) {
		let form = jQuery(this);

		if(evt.relatedTarget === null || (!form.has(evt.relatedTarget) && !jQuery(evt.relatedTarget).is("[type='submit']"))){
			trackContactForm(form, 'Contact Form Abandoned');
		}
	});
});


/* Supports tree-like tables */
var toggleChildRows = function(evt)
{
	evt.preventDefault();

	var parentA     = $(this);
	var parentTR    = parentA.parent().parent();
	var parentTBODY = parentTR.parent();
	var parentTABLE = parentTBODY.parent();
	var parentID    = parentTR.attr('data-id');
	var parentTABLENUM = -1;

	if(parentTABLE.parents('.pinned').length){
		var parentTABLENUM = parentTABLE.parents('.pinned').attr('tablenum');
		if(typeof parentTABLENUM != 'undefined' && parentTABLENUM !== false){
			parentTABLE = $('div.pinned[tablenum="' + parentTABLENUM + '"] table,div.scrollable[tablenum="' + parentTABLENUM + '"] table');
			parentTBODY = $('div.pinned[tablenum="' + parentTABLENUM + '"] table tbody,div.scrollable[tablenum="' + parentTABLENUM + '"] table tbody');
		}
	}

	if('Collapse' == parentA.attr('title'))
	{
		var children = $('tr', parentTBODY).filter('[data-parent^="' + parentID + '"]');

		children.hide();

		$('a.collapse', children).removeClass('collapse').addClass('expand').attr('title', 'Expand').text('Expand');
		parentA.removeClass('collapse').addClass('expand').attr('title', 'Expand').text('Expand');
	}
	else
	{
		var children = $('tr', parentTBODY).filter('[data-parent="' + parentID + '"]');

		children.show();
		parentA.removeClass('expand').addClass('collapse').attr('title', 'Collapse').text('Collapse');
	}

	// Candy striping support
	if(!parentTABLE.hasClass('nostripe'))
	{
		$('tr').removeClass();

		var stripeIndex = 0;
		if(parentTABLE.parents('.pinned').length){
			$('tr', $('div.pinned[tablenum="' + parentTABLENUM + '"] table tbody')).not(':hidden').each(function(index){
				stripeIndex += 1;
				$(this).addClass(0 == stripeIndex % 2 ? 'evenChild' : 'oddChild');
			});
			stripeIndex = 0;
			$('tr', $('div.scrollable[tablenum="' + parentTABLENUM + '"] table tbody')).not(':hidden').each(function(index){
				stripeIndex += 1;
				$(this).addClass(0 == stripeIndex % 2 ? 'evenChild' : 'oddChild');
			});
		}else{
			$('tr', parentTBODY).not(':hidden').each(function(index){
				stripeIndex += 1;
				$(this).addClass(0 == stripeIndex % 2 ? 'evenChild' : 'oddChild');
			});
		}
	}

	writeTreeSessionStorage(parentTABLE);
}

var writeTreeSessionStorage = function(parentTABLE)
{
	// HTML5 session storage
	if('undefined' !== typeof(Storage))
	{
		var path       = window.location.pathname.replace(/\//g, '_');
		var dataID     = [];
		var dataStatus = [];


		sessionStorage[ 'tree' + path ] = '';

		$('tr[data-id]', parentTABLE).each(function(index){
			dataID[        dataID.length] = $(this).attr('data-id');
			dataStatus[dataStatus.length] = $('a', $(this)).first().hasClass('collapse');
		})

		dataID     =     dataID.join(',');
		dataStatus = dataStatus.join(',');

		sessionStorage[ 'tree' + path ] +=     dataID + '|';
		sessionStorage[ 'tree' + path ] += dataStatus + '|';
	}
};

var readTreeSessionStorage = function(parentTABLE)
{
	var path = window.location.pathname.replace(/\//g, '_');

	// HTML5 session storage
	if('undefined' !== typeof(Storage) && sessionStorage[ 'tree' + path ])
	{
		var dataID     = sessionStorage[ 'tree' + path ].split('|')[0].split(',');
		var dataStatus = sessionStorage[ 'tree' + path ].split('|')[1].split(',');

		$('tr[data-id]', parentTABLE).hide();
		$('tr[data-id] a.inline.collapse').text('Expand').attr('title', 'Expand').removeClass('collapse').addClass('expand');
		$('tr[data-id]', parentTABLE).first().show();

		for(var i = 0; i < dataID.length; i++)
		{
			if('true' === dataStatus[i])
				$('tr[data-id="' + dataID[i] + '"] a.inline.expand').trigger('click');
		}
	}
	else
	{
		$('a.inline.collapse', parentTABLE).first().trigger('click').trigger('click');
	}
}

/* Displays a confirmation banner */
var displayConfirmationBanner = function(evt)
{
	evt.preventDefault();

	var target    = $(evt.target);
	var banner    = $('<p />');
	var yesButton = $('<input />');
	var  noButton = $('<input />');
	var after     = $('article h2');

	if(!after.length)
		after = $('article h1');

	after = after.first();

	banner.addClass('banner');
	banner.addClass('example');
	banner.text(target.attr('data-message') ? target.attr('data-message') : target.attr('title') ? target.attr('title') : target.attr('href'));

	yesButton.val('Yes'); yesButton.attr('type', 'button');
	 noButton.val('No');  noButton.attr('type', 'button');

	yesButton.on('click', function(evt){
		if(undefined != target.attr('data-submit') && 'true' == target.attr('data-submit'))
			target.closest('form').get(0).submit()
		else
			window.location = target.attr('href');

		closeAlertBanner(evt);
	});
	noButton.on('click', closeAlertBanner);

	 noButton.prependTo(banner);
	yesButton.prependTo(banner);

	banner.insertAfter(after);

	banner.animate({ top: 0, marginBottom: 0 }, 400);

	$("html, body").animate({ scrollTop: 0 }, 100);
};

/* Displays an alert banner */
var displaySuccessBanner = function(msg){ displayAlertBanner(msg, 'success'); };
var displayWarningBanner = function(msg){ displayAlertBanner(msg, 'warning'); };
var displayFailureBanner = function(msg){ displayAlertBanner(msg, 'failure'); };
var displayExampleBanner = function(msg){ displayAlertBanner(msg, 'example'); };

var displayAlertBanner = function(msg, type)
{
	console.log(msg);
	var banner = $('<p />');
	var close  = $('<a />');
	var after  = $('article h2');
	var article = $('article');

	if(!after.length)
		after = $('article h1');

	after = after.first();

	if(undefined == type || ('example' != type && 'success' != type && 'warning' != type && 'failure' != type))
		type = 'example';

	banner.addClass('banner');
	banner.addClass(type);
	banner.html(msg);

	close.addClass('close' + type);
	close.addClass('icon');
	close.text('Close');
	close.attr('href',  '#');
	close.attr('title', 'Close');
	close.on('click', closeAlertBanner);

	close.prependTo(banner);

	banner.prependTo(article);

	//banner.insertAfter(after);

	banner.animate({ top: 0, marginBottom: 10 }, 400);

	$("html, body").animate({ scrollTop: 0 }, 100);
};

/* Closes an alert or confirmation banner */
var closeAlertBanner = function(evt)
{
	evt.preventDefault();

	var target = $(evt.target);
	var banner = target.parent();

	banner.animate({ top: -150, marginBottom: -42 }, 400, function(){ banner.remove(); });
}

/* Template support - DO NOT REMOVE */
window.jQuery || document.write('<script src = "/scripts/jquery-1.8.1.min.js"><\/script>');


/* visibility plugin. used in scroll animation
(function($) {
  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   *

  $.fn.visible = function(partial) {

	  var $t            = $(this),
		  $w            = $(window),
		  viewTop       = $w.scrollTop(),
		  viewBottom    = viewTop + $w.height(),
		  _top          = $t.offset().top,
		  _bottom       = _top + $t.height(),
		  compareTop    = partial === true ? _bottom : _top,
		  compareBottom = partial === true ? _top : _bottom;

	return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };

})(jQuery);*/

function visible(elem, partial){
	//Based on the above plugin by Sam Sehnert
	let el = jQuery(elem);
	let win = jQuery(window);
	let viewTop = win.scrollTop();
	let viewBottom = viewTop + win.height();
	let elTop = el.offset().top;
	let elBottom = elTop + el.height();
	let compareTop = partial === true ? elBottom : elTop;
	let compareBottom = partial === true ? elTop : elBottom;

	return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
}

function setQuote(shift=0){
	/* Advances the quote slideshow by the given amount */
	if(shift == 0) return;	//Don't do anything if the quote didn't change
	let quoteSlides = jQuery(".quoteBanner .quoteContent");
	let currentSlide = jQuery(".quoteBanner .quoteContent.active").first();

	const mod = (a, b) => {return (((a % b) + b) % b)};

	//Shift slides from the start to the end or visa versa so the active slide stays in the middle
	let targetIndex = Math.ceil(quoteSlides.length / 2);
	let curIndexOfNext = mod(currentSlide.index() + shift, quoteSlides.length);
	let nextSlide = jQuery(quoteSlides[curIndexOfNext]);
	quoteSlides.css("transition", "none");
	if(targetIndex < curIndexOfNext){
		for(let i=0; i<(curIndexOfNext - targetIndex); i++){
			//Move a slide from the start to the end of the slideshow
			let tempSlide = jQuery(quoteSlides[i]);
			let slideWrapper = tempSlide.parent();
			tempSlide.remove();
			slideWrapper.append(tempSlide);
		}
	}
	else{
		for(let i=0; i<(curIndexOfNext - targetIndex); i++){
			//Move a slide from the end to the start of the slideshow
			let tempSlide = jQuery(quoteSlides[quoteSlides.length - 1 - i]);
			let slideWrapper = tempSlide.parent();
			tempSlide.remove();
			slideWrapper.prepend(tempSlide);
		}
	}
	window.setTimeout(()=>{
		//Delay the restoration of the transitions to prevent the slide shuffling done above from being visible
		quoteSlides.removeAttr("style");
		currentSlide.removeClass("active");
		nextSlide.addClass("active");
	}, 10);
}

// Define gtag if it doesn't exist yet
window.gtag = window.gtag || function() {
	(window.dataLayer = window.dataLayer || []).push(arguments);
};

var toggleContactForm = function(){
	var contactForm = $('header .contactArea');
	var hamburger = $('.mNavMenu');

	if (contactForm.hasClass("active")){
		contactForm.removeClass("active");
		hamburger.removeClass('is-down');

		setTimeout(function() {
			contactForm.addClass("hidden");
		}, 500);

		if ($(".contactForm .preSubmit").css("display") == "none")
		{
			setTimeout(function(){
				$(".contactForm .preSubmit").css("display", "block");
				$(".contactForm .postSubmit").css("display", "none");
			}, 500);
		}

	}
	else{
		contactForm.removeClass("hidden");
		// Wait 1ms for "display: none" from .hidden to go away
		setTimeout(function(){
			contactForm.addClass("active");
			hamburger.addClass('is-down');
			if (typeof gtag !== 'undefined'){
				gtag('event', 'page_view', {
					'page_location': '/contact'
				});
			}
			else{
				(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
					new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
					'https://www.googletagmanager.com/gtag/js?id='+i+dl;f.parentNode.insertBefore(j,f);
					})(window,document,'script','dataLayer','G-2L0WFBL8B5');

				gtag('config', 'G-2L0WFBL8B5');
				gtag('event', 'page_view', {
					'page_location': '/contact'
				});
			}
		}, 1);
	}
}

var once = function(fn, context) { 
	var result;

	return function() { 
		if(fn) {
			result = fn.apply(context || this, arguments);
			fn = null;
		}

		return result;
	};
}

/* Google Analytics event tracking */
var trackGaEvent = function(eventCategory, eventAction, eventLabel, urlAction, url){
	// Standard callback
	let analyticsCallbackTriggered = false;
	function analyticsCallback(){
		if(analyticsCallbackTriggered) return;	//Only run once each time trackGaEvent is called
		analyticsCallbackTriggered = true;
		if(url != undefined){
			if(urlAction != undefined && urlAction.indexOf('blank') > -1)
				window.open(url);
			else
				window.location = url;
		}
	}

	$.ajax({
		url: '/cfcs/pageGW.cfc',
		data: {
			method : 'getGaEventTrackingAJAX'
		},
		cache: false,
		dataType: 'json',
		success: function(result){
			if(result.TRACK){
				ga('send', {
					'hitType': 'event',
					'eventCategory': eventCategory,
					'eventAction': eventAction,
					'eventLabel': eventLabel,
					'hitCallback': analyticsCallback
				});
			}
			else{
				analyticsCallback();
			}

			if (result.SHOWAVIBE){
				console.log("****** A-VIBE Only -- Google Analytics event tracking code ******");
				console.log("ga('send', { hitType: 'event', eventCategory: " + eventCategory + ", eventAction: " + eventAction + ", eventLabel: " + eventLabel + " });");
			}
		},
		error: function(jqXHR, status, thrown){
			console.log('Event Tracking Error');
			analyticsCallback();
		}
	});
	//Fallback in case the google analytics or tag manager aren't loaded/triggered properly
	window.setTimeout(analyticsCallback, 2000);
}

var getReferredBy = function(id) {
	$.ajax({
		url      : '/cfcs/adminLeadGW.cfc',
		data     : {
			method : 'getLeadReferredBysAJAX',
			id : id
		},
		cache    : false,
		dataType : 'json',
		success  : function(result)
		{
			return result;
		}
	});	
}

function stripHTML(el){
	if(typeof el === "undefined") return "";
	else if($.type(el) === 'string')
		return el.replace(/(<([^>]+)>)/ig," ").replace(/\s\s+/g, ' ').replace(/"/g, '\"').replace(/'/g, '\'').trim();
	else
		return el.html().replace(/(<([^>]+)>)/ig," ").replace(/\s\s+/g, ' ').replace(/"/g, '\"').replace(/'/g, '\'').trim();
}

var getEventCategory = function(referer) {
	var eventCategory = 'Visitor';

	return eventCategory;
}

var trackLinkClick = function(el, eventAction, referer, currentPath, includeURL, eventLabelText) {
	var eventCategory = getEventCategory(referer),
		urlAction = el.attr('target'),
		url = el.attr('href'),
		labelText = eventLabelText != undefined ? stripHTML(el) + ' ' + eventLabelText : stripHTML(el);

	if(el.attr('href') != undefined)
		href = el.attr('href');
	else
		href = '';

	var eventLabel  = labelText + '|';
		eventLabel += 'Referer: ' + referer + ' |';
		eventLabel += 'Current Page: ' + currentPath + '|';
		eventLabel += 'Link URL: ' + href;

	if(includeURL == true)
		trackGaEvent(eventCategory, eventAction, eventLabel, urlAction, url);
	else
		trackGaEvent(eventCategory, eventAction, eventLabel);
}

var getLinkData = function(e, el, eventAction) {
	var target = el.attr('target');

	if(target == undefined || target.indexOf('blank') < 0)
		e.preventDefault();

	var paths = getPaths();
	var referer = paths.referer;
	var currentPath = paths.currentPath;

	trackLinkClick(el, eventAction, referer, currentPath, true);
}

var getFormName = function(form) {
	var formID = form.attr('id');

	if(formID == 'contactForm')
		var formName = 'Contact Form in Header';
	else if(formID == 'portraitContactForm')
		var formName = 'Contact Page Form';
	else if(formID == 'stayInformedForm')
		var formName = 'Stay Informed Form';
	else if(formID == 'consultationForm')
		var formName = 'Consultation Form';
	else
		var formName = 'Contact Form';

	return formName;
}

var trackContactForm = function(form, eventAction) {
	var formName = getFormName(form);
	var formID = form.attr('id');
	var paths = getPaths();
	var eventCategory = 'Visitor';
	var email = stripHTML($('#' + formID + ' input[name="email"]').val());
	var company = stripHTML($('#' + formID + ' input[name="company"]').val());
	
	if(formName == 'Stay Informed Form') {
		var firstName = stripHTML($('#' + formID + ' input[name="firstName"]').val());
		var lastName = stripHTML($('#' + formID + ' input[name="lastName"]').val());

		if(firstName.length > 0 || lastName.length > 0 || email.length > 0 || company.length) {
			var eventLabel  = formName + '|';
				eventLabel += 'Name: ' + firstName + ' ' + lastName + '|';
				eventLabel += 'Email: ' + email + '|';
				eventLabel += 'Company: ' + company + '|';
				eventLabel += 'Referer: ' + paths.referer + ' |';
				eventLabel += 'Current Page: ' + paths.currentPath;

			trackGaEvent(eventCategory, eventAction, eventLabel);
		}
	} else {
		var firstName = stripHTML($('#' + formID + ' input[name="firstname"]').val());
		var lastName = stripHTML($('#' + formID + ' input[name="lastname"]').val());
		var phone = stripHTML($('#' + formID + ' input[name="phone"]').val());
		var message = stripHTML($('#' + formID + ' textarea[name="message"]').val());
		var referredBySelect = $('#' + formID + ' select[name="referredBy"]');

		if(referredBySelect != undefined && referredBySelect.length > 0)
			var referredBy = referredBySelect.val() > 0 ? stripHTML(referredBySelect.find('option:selected')) : '';
		else
			var referredBy = $('#' + formID + ' input[name="referredBy"]').val() > 0 ? getReferredBy($('#' + formID + ' input[name="referredBy"]').val()) : '';

		if(firstName.length > 0 || lastName.length > 0 || email.length > 0 || phone.length > 0 || company.length > 0 || referredBy.length > 0 || message.length > 0) {
			var eventLabel  = formName + '|';
				eventLabel += 'Name: ' + firstName + ' ' + lastName + '|';
				eventLabel += 'Email: ' + email + '|';
				eventLabel += 'Phone: ' + phone + '|';
				eventLabel += 'Company: ' + company + '|';
				eventLabel += 'Referred By: ' + referredBy + '|';

			if(formName == 'Consultation Form') {
				var budget = $('#' + formID + ' select[name="budget"]').val() > 0 ? stripHTML($('#' + formID + ' select[name="budget"] option:selected')) : '';
				var projectType = $('#' + formID + ' select[name="projectType"]').val() > 0 ? stripHTML($('#' + formID + ' select[name="projectType"] option:selected')) : '';
			
				eventLabel += 'Budget: ' + budget + '|';
				eventLabel += 'Project Type: ' + projectType + '|';
			}

				eventLabel += 'Message: ' + message + '|';
				eventLabel += 'Referer: ' + paths.referer + ' |';
				eventLabel += 'Current Page: ' + paths.currentPath;

			trackGaEvent(eventCategory, eventAction, eventLabel);
		}
	}
}

loadEvents.push(function(){
	/* (Safari fix) Check if the browser has overwritten the provided styles for the contact form select field */
	let contactFormSelect = document.querySelector(".contactForm select");
	if(contactFormSelect === null) return;
	if(getComputedStyle(contactFormSelect).borderTopLeftRadius != "0px"
		|| getComputedStyle(contactFormSelect).paddingTop != "7.5px"){
		//The browser has overwritten the CSS styles for the select element
		document.querySelector(":root").classList.add("needsSafariFix");
	}
});
//Defer image loading
window.addEventListener("pageshow", ()=>{
	let images = document.querySelectorAll("img.deferred");
	for(const i of images){
		i.setAttribute("loading", "lazy");
		i.setAttribute("src", i.dataset.src);
		i.removeAttribute("data-src");
	}
	window.setTimeout(()=>{
		for(const i of images){
			i.removeAttribute("loading");
		}
	}, 5000);
});